import { buildRunIdParam } from 'src/common/helpers/GQLRequestsHelper/buildRunIdParam';

import { MfaSessionSummaryQueryVariables } from '../MfaSessionSummary.generated';

export const buildMfaSessionSummaryQueryVariables = (
	sessionId: string
): MfaSessionSummaryQueryVariables => ({
	runId: buildRunIdParam(sessionId).runId
});
